
  import { Component, Prop, Vue }                       from 'vue-property-decorator';
  import { Getter }                                     from 'vuex-class';
  import { EventBus,
           ConfigService,
           ConfigThemeService }                         from '../../';
  import   CarouselComponent                            from '../carousel/CarouselComponent.vue';

  @Component({
    name: 'DrawerComponent',
    components: {
      CarouselComponent
    }
  })
  export default class DrawerComponent extends Vue {
    @Prop() tabClassName?:string;
    @Getter('isPresentationAvatarAllowed', { namespace: 'conversationSession' }) isPresentationAvatarAllowed!: boolean;

    isDisplayed: boolean = false;
    mustBeOpened: boolean = false;
    allElements: NodeListOf<HTMLElement> | null  = null;
    elementIndex: number = 0;

    /** ******************************************************************** */
    /**                      Get styles                                      */
    /** ******************************************************************** */

    get drawerStyles() {
      return ConfigThemeService.getDrawerStyles(this.$vuetify);
    }

    get drawerCloseIcon() {
      return ConfigThemeService.getCloseDrawerPanelIcon();
    }

    get drawerIconColor() {
      return ConfigThemeService.getDrawerIconsColor(this.$vuetify); 
    }

    get drawerCloseIconColor() {
      return ConfigThemeService.getDrawerCloseIconColor(this.$vuetify);
    }
    
    get drawerIconBgColor() {
      return ConfigThemeService.getDrawerIconsBgColor(this.$vuetify); 
    }
    
    get drawerCloseButtonTitle() {
      return ConfigService.getCloseDrawerButtonTitle(); 
    }

    /** ******************************************************************** */
    /**                      Action management                               */
    /** ******************************************************************** */

    playCloseAnimation() {
      this.mustBeOpened = false;
      setTimeout(this.closeDrawerComponent, 1000);
    }

    showDrawerComponent() {
      this.isDisplayed = true;
      this.mustBeOpened = true;
      EventBus.$emit('ON_DRAWER_OPEN');
    }

    closeDrawerComponent() {
      this.isDisplayed = false;
      EventBus.$emit('ON_DRAWER_CLOSE');
    }

    /** ******************************************************************** */
    /**                      LIFECYCLE HOOKS FUNCTIONS                       */
    /** ******************************************************************** */

    created() {
    }

    mounted(){
      EventBus.$on('ON_IMAGE_SELECTED', (allElements: NodeListOf<HTMLImageElement | HTMLTableElement>, elementIndex: number) => {
        this.allElements = allElements;
        this.elementIndex = elementIndex;
        this.showDrawerComponent();
      });

      EventBus.$on('ON_TABLE_SELECTED', (allElements: NodeListOf<HTMLImageElement | HTMLTableElement>, elementIndex: number) => {
        this.allElements = allElements;
        this.elementIndex = elementIndex;
        this.showDrawerComponent();
      });

      EventBus.$on('ON_MESSAGE_SENT', () => {
        if (this.mustBeOpened) {
          this.playCloseAnimation();
        }
      });

      EventBus.$on('ON_CLOSE_CONVERSATION_PANEL', () => {
        this.closeDrawerComponent();
      });
    }

    destroyed() {
      EventBus.$off('ON_IMAGE_SELECTED');
      EventBus.$off('ON_TABLE_SELECTED');
      EventBus.$off('ON_MESSAGE_SENT');
      EventBus.$off('ON_CLOSE_CONVERSATION_PANEL');
    }
  }
